<template>
  <div>
    <vx-card class="mb-1">
        <vs-row vs-type="flex" vs-justify="space-between" >
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="8">         
              <label class="vs-input--label mr-2">Razão Social</label>              
          </vs-col>          
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">         
          </vs-col>
       </vs-row>
       <vs-row vs-type="flex" vs-justify="space-between" >
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="8">                       
              <vs-input class="mb-4 w-full" v-model="filtro.razaoSocial" @keyup.enter="fetchLista(filtro)" />
          </vs-col>
          
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="fetchLista(filtro)"></vs-button>
            <vs-button class="mr-2" color="dark" type="border" icon-pack="feather" icon="icon-file" @click="limparFiltros"></vs-button>  
            <vs-button class="mr-2" color="warning" type="filled" icon-pack="feather" icon="icon-plus" @click="routeNovoRegistro"></vs-button>          
            <vs-button color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-save" @click="exportarParaCSV"></vs-button>          
          </vs-col>
      </vs-row>
    </vx-card>
     
    <h6 class="ml-2 mt-2 mb-2 text-danger"> {{dadosDaGrid.length }} registros </h6>
    <vx-card class="mb-1">
      <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="dadosDaGrid"
        :rowHeight="25"
        :headerHeight="25"        
        rowSelection="single"
        colResizeDefault="shift"
        @row-selected="onRowSelectedRegistro"    
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :paginationAutoPageSize="false"
        :suppressPaginationPanel="true"
        >
      </ag-grid-vue>      
    </vx-card>
    
  </div>

</template>

<script>
import axios from "@/axios.js"
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

const URL_SERVLET = "/Empresa/ListarEmpresa";
const NAME_ROUTE_EDIT = "cadastro-empresas-editar";

export default {
  components: {
    AgGridVue
  },
  data() {
    return {
      filtro : {razaoSocial: null},
      configuracaoGrid: { 
          gridApi: null, gridOptions: {
            rowClassRules: {          
              'rag-cancelada':   function(params) { return params.data.excluido; },
            },
          }, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [        
            { headerName: 'NOME', field: 'razaoSocial', width: 75 },                       
            { headerName: 'RAZÃO SOCIAL', field: 'razaoSocial', width: 75},
            { headerName: 'CNPJ', field: 'cnpj', width: 75},                
            { headerName: 'INATIVO', field: 'excluido', width: 75,
              cellRenderer: function(params) {
                  return (params.data.excluido ? 'S' : 'N') 
              }
            },                
          ]
      },
      dadosDaGrid: [],
      totalRegistros: 0      
    }
  },  
  created() {
  },
  methods: {
    limparFiltros() {
      this.filtro = {razaoSocial:  null};      
    },
    fetchLista(pFiltro) {     
      this.$vs.loading() 
      const params = new URLSearchParams();
      params.append('pagina', -1);
      
      if (pFiltro.razaoSocial) {
        params.append('razaoSocial', pFiltro.razaoSocial);
      }

      axios.post(URL_SERVLET, params, {   
              headers: {'Accept': 'application/json' },           
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/' });
          } else {
            this.totalRegistros = response.data.Resultado.quantidade;              
            this.dadosDaGrid = response.data.Resultado.lista;
              
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
      })    
                        
    },
    routeNovoRegistro() {
      let self_ = this;

      self_.$router.push({
            name: NAME_ROUTE_EDIT                     
      })
    },
    onRowSelectedRegistro(evento) {
      let self_ = this;
      let registro = evento.node.data;
      
      self_.$router.push({
            name: NAME_ROUTE_EDIT,
            params: {
              registroOriginal: registro
            }
      })

    },
    exportarParaCSV() {
      var params = {columnSeparator: ';', fileName: 'Empresas.csv'};
      this.configuracaoGrid.gridApi.exportDataAsCsv(params);
    }
    
  },
  mounted() {
    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api;
    this.configuracaoGrid.gridApi.sizeColumnsToFit();      
    this.fetchLista(this.filtro);
    
  }
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 320px);
  }
</style>

<style lang="scss">
  
  .rag-green-outer {
    background-color: rgb(252, 222, 196) !important;
  }

  .rag-amber-outer {
    background-color: rgb(250, 74, 74) !important;
    color: white  !important;
  }

  .rag-cancelada {
     color: grey !important;
     background-color: rgb(225, 230, 161) !important;
     
  }
</style>